import { lazy } from 'react';
import { type RouteObject } from 'react-router-dom';

import { IS_APP_RUNNING_IN_RN } from '@~/constants/app-config';

import { SPECIAL_ROUTES } from '../route-constants';
import { AUTH_ROUTES } from './auth-routes';
import { PRIVATE_ROUTES } from './private-routes';
import { PUBLIC_ROUTES } from './public-routes';

const NotFoundPage = lazy(() => import('@~/pages/404/404'));
const AutoLoginViaCuemathApp = lazy(() => import('@~/pages/auto-login-via-cuemath-app'));

/**
 * 404 route configuration
 */
const NO_MATCH_ROUTE: RouteObject = {
  path: SPECIAL_ROUTES.NOT_FOUND.PATH,
  element: <NotFoundPage />,
  handle: {
    pageName: SPECIAL_ROUTES.NOT_FOUND.NAME,
  },
};

/**
 * React Native specific routes
 */
const RN_SPECIFIC_ROUTES: RouteObject = {
  path: SPECIAL_ROUTES.AUTO_LOGIN.PATH,
  element: <AutoLoginViaCuemathApp />,
  handle: {
    pageName: SPECIAL_ROUTES.AUTO_LOGIN.NAME,
  },
};

/**
 * Build the complete routes array
 */
const buildRoutes = (): RouteObject[] => {
  const routes = [PRIVATE_ROUTES, AUTH_ROUTES, PUBLIC_ROUTES, NO_MATCH_ROUTE];

  if (IS_APP_RUNNING_IN_RN) {
    routes.push(RN_SPECIFIC_ROUTES);
  }

  return routes;
};

const ROUTES = buildRoutes();

export { ROUTES };
